import * as React from "react";

import "./quote.scss";

export const Quote: React.FC = ({ children }) => {
  return <div className="quote">{children}</div>;
};
